module.exports = __webpack_public_path__ + "media/images/congrats-7c2943f977012cec6ceb75e3045ed904.png";